import type { Moment } from 'moment'

import { EventModel } from '@/app/models/newDelegation/eventModel'


const DRAG_ONLY_FIELDS = [
  'position',
  'translate',
  'isDragging',
  'rawDate',
  'time',
  'dropArea',
] as const


export type MarkerDropArea = {
  left: number
  top: number
  width: number
  height: number
}


export const MARKER_DROP_SLACK = 15

export const toMovedEventPayload = (item: any, date: Moment): EventModel => {
  const event = { ...item }
  for (const field of DRAG_ONLY_FIELDS) {
    delete event[field]
  }
  return { ...event, date, isNew: false, temporary: false }
}
